import { IsTruthy } from "@swivl-mono/helpers";
import { LocationVarKey } from "@swivl-mono/types";
import { Button, ButtonSize, ButtonVariant } from "@swivl-mono/ui";
import { useState } from "react";
import { FiMessageSquare } from "react-icons/fi";

import LocationVarsModel from "../../../Models/Variables/LocationVars.Model";
import { SnowyCampaignModal } from "./SnowyCampaignModal";

/**
 * "New SMS Campaign" on the Contact Center v3 nav (ENG-3114). Gated by the org's
 * `CortexIsSMSCampaignsEnabled` (Gate 3 — per-org enablement). Opens the Snowy compose
 * modal; the legacy SMSCampaignButton/BroadcastModal stay on legacy routes.
 */
export function SnowyCampaignButton(): React.ReactNode {
  const vars = LocationVarsModel.useState((s) => s);
  const [open, setOpen] = useState(false);
  const enabled = IsTruthy(vars?.orgVariables?.[LocationVarKey.CortexIsSMSCampaignsEnabled]?.value);
  if (!enabled) return null;

  const handleOpen = (): void => setOpen(true);
  const handleClose = (): void => setOpen(false);

  return (
    <>
      <Button size={ButtonSize.SMALL} variant={ButtonVariant.GHOST} onClick={handleOpen}>
        <FiMessageSquare size={13} /> New SMS Campaign
      </Button>
      {open && <SnowyCampaignModal open={open} onClose={handleClose} />}
    </>
  );
}
